import BaseError from './BaseError';

class TeamError extends BaseError {}

export default TeamError;
